import { useWavesurfer } from "@wavesurfer/react";
import React, { useRef } from "react";
import { getImageUrl } from "../../../../utils/image-helper/get-image-url";
import './wavesurfer-audio-player.css';
import { LoadingOutlined } from "@ant-design/icons";

type WaversurferAudioPlayerProps = {
    waveColor: string;
    src: string;
    height: number;
};

export const WaversurferAudioPlayer = ({ waveColor, src, height }: WaversurferAudioPlayerProps) => {
    const containerRef = useRef(null);
    const { wavesurfer, isReady, isPlaying, currentTime } = useWavesurfer({
        container: containerRef,
        url: src,
        waveColor,
        height
    });
    const onPlayPause = () => {
        wavesurfer && wavesurfer.playPause();
    };

    return (
        <div className="waversurfer-player-container">
            <div ref={containerRef} className='waversurfer-container' />
            {
                !isReady && <LoadingOutlined className='loader' />
            }
            {
                isReady && (
                    <img
                        onClick={onPlayPause}
                        className='audio-play-button'
                        src={getImageUrl('play-button.png')}
                        alt="play-button"
                    />
                )
            }
        </div>
    );
};